// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://glltrmyzpemvuljnurpv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdsbHRybXl6cGVtdnVsam51cnB2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE0Mzg1NzYsImV4cCI6MjA1NzAxNDU3Nn0.C6BmJinRRtdCrhIQjpE6bs1sb6_QFMOoDMGGFx1oNT0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});